import { finalization } from '@r1-frontend/bp42/actions';
import CallbackForm from '@r1-frontend/bp42/containers/CallbackForm';
import ResultPopup from '@r1-frontend/bp42/containers/ResultPopup';
import selectDataForMainPopup from '@r1-frontend/bp42/selectors/selectDataForMainPopup';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { useCtxDispatch, useCtxSelector, useIncomingCallbacks } from '../hooks';

const CallbackPopup = (): JSX.Element => {
    const callbacks = useIncomingCallbacks();
    const { isPopupOpen } = useCtxSelector(selectDataForMainPopup);
    const dispatch = useCtxDispatch();
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const handleOnClose = () => {
        callbacks.onClose();
        dispatch(finalization());
    };

    return (
        <>
            <DefaultPopup
                isOpen={isPopupOpen}
                onClose={handleOnClose}
                width={isMobile ? '343px' : '600px'}
            >
                <CallbackForm/>
            </DefaultPopup>
            <ResultPopup/>
        </>
    );
};

export default CallbackPopup;
